import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <section className="flex flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <p className="font-heading text-7xl font-black text-background-300 md:text-9xl">404</p>
      <h1 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        这个页面暂时没有内容
      </h1>
      <p className="mt-2 text-sm font-label text-foreground-400">{location.pathname}</p>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600 font-label">
        链接可能已经调整，或者这条事件记录还没有整理完成。回到首页或今日热榜，继续看看当下大家都在聊什么。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/hot"
          className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          查看今日热榜
        </Link>
      </div>
    </section>
  );
}